import React, { useEffect } from "react";
import SmoothScroll from "@/components/SmoothScroll";
import { SiteProvider } from "@/context/SiteContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { About } from "@/components/About";
import { QuoteBanner } from "@/components/QuoteBanner";
import { Manifesto } from "@/components/Manifesto";
import { Journey } from "@/components/Journey";
import { Gallery } from "@/components/Gallery";
import { ProjectTeaser } from "@/components/ProjectTeaser";
import { PreSave } from "@/components/PreSave";
import { Platforms } from "@/components/Platforms";
import { LiveChat } from "@/components/LiveChat";
import { Newsletter } from "@/components/Newsletter";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { trackPageview } from "@/lib/analytics";

export default function Landing() {
  useEffect(() => {
    trackPageview("/");
  }, []);

  return (
    <SiteProvider>
      <div className="App grain">
        <SmoothScroll>
          <Nav />
          <main>
            <Hero />
            <Stats />
            <EditorialMarquee />
            <About />
            <QuoteBanner />
            <Manifesto />
            <Journey />
            <Gallery />
            <ProjectTeaser />
            <PreSave />
            <Platforms />
            <LiveChat />
            <Newsletter />
            <Contact />
          </main>
          <Footer />
        </SmoothScroll>
      </div>
    </SiteProvider>
  );
}
